import { RawUserCountries } from "./user_countries.types";
import { Country } from "@/entities/country";

export class UserCountries {
  readonly countries: Country[];
  constructor(data: RawUserCountries) {
    this.countries = data.countries ? data.countries.map((value) => new Country(value)) : [];
  }
}
